import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { MID_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${MID_GREY}`,
  },
  rootActions: { borderBottom: `1px solid ${MID_GREY}` },
  rootFooter: {
    backgroundColor: "#FFF",
    boxShadow: "0px -9px 25px rgba(0, 0, 0, 0.12)",
    position: "fixed",
    left: 0,
    bottom: 0,
    width: "100%",
    padding: theme.spacing(1, 5),
  },
  imgIconNewArt: { width: theme.spacing(5), height: theme.spacing(5) },
}));
